import {
    FETCH_COMPANY_INFO_SUCCESS,
    FETCH_COMPANY_INFO_REQUEST_LOADING,
} from "api/menu/master-files/company-info/actions";

const initialState = {
    loading: false,
    errors: [],
    companyInfo: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case FETCH_COMPANY_INFO_REQUEST_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_COMPANY_INFO_SUCCESS:
            return {
                loading: false,
                errors: [],
                companyInfo: action.payload
            };
        default:
            return state;
    }
}
